<gc-modal
  class="installation-reporting-mdu-modal"
  [headerTitle]="'installationReportingMduModal.header' | translate"
  [showCloseIcon]="true"
  [width]="'fullscreen'"
  [closeOnOutsideClick]="false"
  [primaryButtonText]="
    (isBom()
      ? 'installationReportV2.orderOverviewTab.undoBom'
      : 'installationReportV2.modal.saveBtn'
    ) | translate
  "
  [primaryButtonIcon]="isBom() ? 'circularArrow' : undefined"
  [primaryButtonIsLoading]="isLoading()"
  [primaryButtonIsDisabled]="isLoading()"
  (closeModal)="closeModal()"
  (primaryButtonClicked)="onPrimaryButtonClicked()"
>
  <ng-template #orderOverview>
    <app-installation-report-overview-tab
      [building]="buildingForOverview()"
      [deliveryPoint]="deliveryPointForOverview()"
      [overview]="overview()"
      [isBom]="isBom()"
      [isBomSaving]="isBomSaving()"
      (bomMarked)="onBomMarked($event)"
    />
  </ng-template>

  <div class="installation-reporting-mdu-modal-dropdown">
    <gc-dropdown-button
      [activeItemId]="activeTab()"
      [ariaLabel]="'installationReportV2.modal.header' | translate"
      (listItemClicked)="onDropdownItemClicked($event)"
    >
      <gc-list-item
        [id]="InstallationReportTab.ORDER_OVERVIEW"
        [label]="'installationReportV2.tabNames.ORDER_OVERVIEW' | translate"
        [active]="activeTab() === InstallationReportTab.ORDER_OVERVIEW"
      />
      @for (section of sections(); track section.id) {
        <gc-list-item
          [id]="section.id"
          [label]="section.tabNameKey | translate"
          [active]="activeTab() === section.id"
          [disabled]="isBom()"
        />
      }
    </gc-dropdown-button>
  </div>

  <gc-tabs
    class="installation-reporting-mdu-modal-tabs"
    [tabWidth]="'auto'"
    [initialTabIndex]="activeTabIndex()"
    (activeTabChanged)="onActiveTabChanged($event)"
  >
    <gc-tab
      [label]="'installationReportV2.tabNames.ORDER_OVERVIEW' | translate"
      [templateRef]="orderOverview"
    />
    @for (section of sections(); track section.id) {
      <gc-tab
        [label]="section.tabNameKey | translate"
        [templateRef]="sectionTab"
        [aria-disabled]="isBom()"
      />
      <ng-template #sectionTab>
        @if (sectionStates()?.[section.id]; as state) {
          <app-installation-report-section-tab
            [config]="section"
            [address]="address()"
            [contact]="contact()"
            [accessId]="deliveryPointForOverview()?.accessId ?? undefined"
            [preInstallationMacAddress]="preInstallationMacAddress()"
            [showConnectionStatus]="
              report().reportType === 'DELIVERY_POINT' && !isDeliveryPortalFi
            "
            [canMarkNotApplicable]="report().reportType === 'BUILDING'"
            [isNotApplicableSaving]="
              notApplicableSavingSection() === section.id
            "
            [state]="state"
            [mutationLoadingState]="selfInspectionMutationLoadingState()"
            (stateChange)="onSectionStateChanged(section.id, $event)"
            (dateChanged)="onSectionDateChanged(section.id, $event)"
            (selfInspectionCompleted)="onSelfInspectionCompleted($event)"
            (selfInspectionMarkedNotApplicable)="
              onSelfInspectionMarkedNotApplicable($event)
            "
            (selfInspectionUndone)="onSelfInspectionUndone($event)"
            (selfInspectionFilesSelected)="
              onSelfInspectionFilesSelected($event)
            "
            (navigateToPreinstallation)="navigateToPreinstallation()"
            (selfInspectionAttachmentsViewed)="
              onSelfInspectionAttachmentsViewed($event)
            "
            (signingStarted)="openSigningPage()"
            (notApplicableChanged)="
              onSectionNotApplicableChanged(section.id, $event)
            "
          />
        }
      </ng-template>
    }
  </gc-tabs>

  @if (showImagePreview()) {
    <app-image-preview-v2
      [images]="imagePreviewImages()"
      [isLoading$]="isLoadingImagePreview"
      (uploadFiles)="uploadImagesFromPreview($event)"
      (deleteFile)="deleteImageFromPreview($event)"
      (downloadFiles)="downloadImages($event)"
      (closeModal)="closeImagePreview()"
    />
  }
</gc-modal>
